<template>
    <div>
        <vrm-foldable-table :items="usersAndTeams" key-by="id" remove-expandable-class>
            <template v-slot:thead>
                <th>{{ $t('groups.users_and_teams', 'Users and teams') }}</th>
                <th class="table-fixed-width-access-level">
                    {{ $t('users.access_levels') }}
                    <span
                        class="sg-vrm-icon_061_info-round-16px vrm-table__icon--link"
                        @click="showRoleGuideModal"
                    ></span>
                </th>
            </template>
            <template v-slot:main="{ item: userOrTeam, toggle, expanded }">
                <vrm-table-cell-user
                    :user="userOrTeam"
                    admin-key="fullControl"
                ></vrm-table-cell-user>
                <td class="no-border">
                    {{ findAccessLevelOption(userOrTeam.accessLevel).name }}
                </td>
                <td class="vrm-table__actions fixed-width">
                    <a
                        v-if="userOrTeam.isTeam"
                        class="vrm-table__icon--link"
                        :class="
                            expanded
                                ? 'sg-vrm-icon_059_min-round-16px'
                                : 'sg-vrm-icon_058_plus-round-16px'
                        "
                        @click="toggle"
                    />
                </td>
            </template>
            <template v-slot:extra="{ item: team }">
                <vrm-table-users-names
                    v-if="team.isTeam"
                    :users="team.members"
                ></vrm-table-users-names>
            </template>
        </vrm-foldable-table>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmFoldableTable from '@/vue/components/molecules/VrmFoldableTable';
import VrmTableCellUser from '@/vue/components/table/VrmTableCellUser';
import VrmTableUsersNames from '@/vue/components/table/VrmTableUsersNames';
import { findAccessLevelOption } from '@/vue/store/modules/installation-access-level';

@Component({
    components: { VrmFoldableTable, VrmTableCellUser, VrmTableUsersNames },
})
@AngularLocaleBundle('users')
@AngularLocaleBundle('groups')
export default class VrmTableUsersAndTeams extends Vue {
    @Prop()
    usersAndTeams;

    @Prop()
    showRoleGuideModal;

    findAccessLevelOption = findAccessLevelOption;
}
</script>
